<template>
  <form v-if="!isLoading" @submit.prevent="onSubmit">
    <div class="row">
      <div class="col-4">
        <app-input
          v-model="exchange.value"
          v-money="{ ...moneyConfig, prefix: 'R$ ' }"
          label="Valor de Resgate"
          :errors="errors.value"
          required
        ></app-input>
      </div>
      <div class="col-4">
        <app-input
          v-model="exchange.value_store"
          v-money="{ ...moneyConfig, prefix: 'BZ ' }"
          label="Valor para Loja"
          :errors="errors.value_store"
          required
        ></app-input>
      </div>
    </div>
    <div class="row mt-4">
      <div class="col-12">
        <button :disabled="$v.$invalid || saving" type="submit" v-app-button>
          Salvar
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import ExchangeService from '@/services/exchange.service';
import NumberMixin from '@/mixins/NumberMixin';

import { required } from 'vuelidate/lib/validators';

export default {
  name: 'exchanges-form',
  mixins: [NumberMixin],
  props: ['id', 'errors', 'saving'],
  data: () => {
    return {
      isLoading: true,
      exchange: {
        value: null,
        value_store: null,
      },
      moneyConfig: {
        decimal: ',',
        thousands: '.',
        precision: 2,
      },
    };
  },
  validations: {
    exchange: {
      value: { required },
      value_store: { required },
    },
  },
  methods: {
    loadExchange(id) {
      ExchangeService.getId(id)
        .then(({ data: exchange }) => {
          this.exchange = {
            ...exchange,
            value: exchange.value.toFixed(2),
            value_store: exchange.value_store.toFixed(2),
          };
        })
        .catch(() => this.toastify('Erro ao carregar câmbio.', 'error'))
        .finally(() => (this.isLoading = false));
    },
    onSubmit() {
      this.$emit('submit', {
        ...this.exchange,
        value: this.parseDecimalInput(this.exchange.value),
        value_store: this.parseDecimalInput(this.exchange.value_store),
      });
    },
  },
  beforeMount() {
    if (this.id) this.loadExchange(this.id);
    else this.isLoading = false;
  },
};
</script>
